const page = {
  state: {
    pageInfo: null,
    pageTitle: null, // main company logged in
    pageHeading: null,
    pageSubheading: null,
    cardOpen: null
  },
  mutations: {
    changePageInfo(state, payload) {
      state.pageInfo = payload;
    },
    changePageTitle(state, payload) {
      state.pageTitle = payload;
    },
    changePageHeading(state, payload) {
      state.pageHeading = payload;
    },
    changePageSubheading(state, payload) {
      state.pageSubheading = payload;
    },
    changeCardOpen(state, payload) {
      state.cardOpen = payload;
    }
  },
  actions: {
    changePageInfo({ commit }, payload) {
      commit("changePageInfo", payload);
    },
    changePageTitle({ commit }, payload) {
      commit("changePageTitle", payload);
    },
    changePageHeading({ commit }, payload) {
      commit("changePageHeading", payload);
    },
    changePageSubheading({ commit }, payload) {
      commit("changePageSubheading", payload);
    },
    changeCardOpen({ commit }, payload) {
      commit("changeCardOpen", payload);
    }
  },
  getters: {
    getPageInfo: state => {
      return state.pageInfo;
    },
    getPageTitle: state => {
      return state.pageTitle;
    },
    getPageHeading: state => {
      return state.pageHeading;
    },
    getPageSubheading: state => {
      return state.pageSubheading;
    },
    getCardOpen: state => {
      return state.cardOpen;
    }
  }
};
export default page;
